import React from "react";
import {
    Experience,
    LineItemTemplate,
    LineItemTemplateCode,
    LineItemType,
    PurchaseRuleLink,
    PurchaseRuleLinkTag,
} from "types";
import { Loader } from "../../components/Loader";
import { ExperiencePricing } from "../../components/Product/pricing/ExperiencePricing";
import { useCollection } from "../../hooks/useCollection";

export const ExperiencePricingPage = ({ experience }: { experience: Experience }) => {
    const { data: purchaseRuleLinks, isLoading: isLoadingPurchaseRuleLink } = useCollection<PurchaseRuleLink>(
        "purchaseRuleLinks",
        {
            "tags._id": PurchaseRuleLinkTag.PRICING,
            "entities.id": experience.id,
            expand: "purchaseRule",
            limit: 1,
        },
    );

    const { data: schedulePurchaseRuleLinks, isLoading: isLoadingSchedulePurchaseRuleLink } =
        useCollection<PurchaseRuleLink>("purchaseRuleLinks", {
            "tags._id": PurchaseRuleLinkTag.SCHEDULE,
            "entities.id": experience.id,
            expand: "purchaseRule",
            limit: 1,
        });

    const { data: perOutingPriceLineItemTemplates, isLoading: isLoadingPerOutingPriceLineItemTemplates } =
        useCollection<LineItemTemplate>("lineItemTemplates", {
            type: LineItemType.DEMOGRAPHIC,
            code: LineItemTemplateCode.PER_OUTING_PRICE,
        });

    const { data: privateUpgradeLineItemTemplates, isLoading: isLoadingPrivateUpgradeLineItemTemplates } =
        useCollection<LineItemTemplate>("lineItemTemplates", {
            type: LineItemType.FEEABLE_TAXABLE_ADJUSTMENT,
            code: LineItemTemplateCode.PRIVATE_UPGRADE,
        });

    const isLoading =
        isLoadingPurchaseRuleLink ||
        isLoadingPerOutingPriceLineItemTemplates ||
        isLoadingSchedulePurchaseRuleLink ||
        isLoadingPrivateUpgradeLineItemTemplates;

    const purchaseRuleLink = purchaseRuleLinks[0] ?? {};
    const schedulePurchaseRuleLink = schedulePurchaseRuleLinks[0] ?? {};

    if (isLoading) {
        return <Loader />;
    }

    const lineItemTemplates = [...perOutingPriceLineItemTemplates, ...privateUpgradeLineItemTemplates];

    return experience && lineItemTemplates ? (
        <ExperiencePricing
            experience={experience}
            lineItemTemplates={lineItemTemplates}
            purchaseRuleLink={purchaseRuleLink}
            schedulePurchaseRuleLink={schedulePurchaseRuleLink}
        />
    ) : null;
};
